import React, { useState, useRef, useEffect } from 'react'
import Slider from "react-slick";
// React Slick Carousel 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../styles/componentsStyles/Browse/BrowseImages.scss"

import Content from "../../assets/images/content.JPG"
import Content2 from "../../assets/images/thum.jpg"
import Content3 from "../../assets/images/codemmit-logo.png"

const BrowseImages = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    let carouselSettings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 500,
        cssEase: "linear",
        afterChange: current => setActiveSlide(current)
    };



    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                if (activeSlide + 1 >= 1) { sliderRef.slickPrev(); }
            } else if (event.key === 'ArrowRight') {
                if (activeSlide < 3) { sliderRef.slickNext(); }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    return (
        <div className='browse-image'>
            <Slider {...carouselSettings} ref={slider => {
                sliderRef = slider;
            }} className='browse-image__slider'>
                <div className='browse-image__slide'>
                    <img src={Content} alt="content" />
                </div>
                <div className='browse-image__slide'>
                    <img src={Content2} alt="content" />
                </div>
                <div className='browse-image__slide'>
                    <img src={Content3} alt="content" />
                </div>
            </Slider>
            <div className="browse-image__nav-btn-container">
                <div className="browse-image__nav-btn browse-image__nav-btn--prev" onClick={previous}>
                    <span class="material-symbols-outlined">
                        keyboard_arrow_left
                    </span>
                </div>
                <p className='browse-image__slide-count' >
                    {activeSlide + 1}/03
                </p>
                <div className="browse-image__nav-btn browse-image__nav-btn--next" onClick={next}>
                    <span class="material-symbols-outlined">
                        keyboard_arrow_right
                    </span>
                </div>
            </div>
        </div>
    )
}

export default BrowseImages